import { Component, Input, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { Menu } from '../../interface/menu';
import { CommonModule } from '@angular/common';
import { authService } from '../../services/auth.service';
import { EnvironmentService } from '../../../../environments/environment.service';
import { environment } from '../../../../environments/environment.development';
import { MenuService } from '../../services/menu.service';
import { SharedService } from '../../../shared/services/shared.service';
@Component({
  selector: 'app-side-menu',
  imports: [RouterModule, CommonModule],
  templateUrl: './side-menu.component.html',
  styleUrl: './side-menu.component.scss'
})
export class SideMenuComponent implements OnInit {
  @Input() menu: Menu[] = [];
  @Input() vendorMenu: Menu[] = [];
  menu_items: string[] = [];
  isOpen: boolean[][] = [[], [], []];
  isInventory = false;
  isVedors = false;

  // Define isOpen as an object where the key is the level, 
  // and the value is the index of the open item (or null).
  activeIndices: { [key: number]: number | null } = {};

  constructor(
    private router: Router,
    private authService: authService,
    public menuService: MenuService,
    public environmentService: EnvironmentService,
    private sharedService:SharedService
  ) { }

  ngOnInit(): void {
    this.menuService.menu = this.menu;
    this.menu_items = this.authService.getUserInfo()?.menu_item;
    const currentRoute = this.router.url.split('/')[1];
    this.isInventory = currentRoute == 'inventory' ? true : false;
    this.isVedors = currentRoute == 'vendors' ? true : false;
    this.setupTypeIdData();
  }

  toggleOpen(index: number, level: number): void {
    // If the clicked index is ALREADY the active one, close it (set to null)
    if (this.activeIndices[level] === index) {
      this.activeIndices[level] = null;
    } else {
      // Otherwise, set this index as the active one (automatically replaces the old one)
      this.activeIndices[level] = index;
    }
  }

  // toggleOpen(index: number, level: number): void {

  onClick1(...menus: Menu[]) {
    if (menus.length && !menus[0].child?.length) {
      const type_id=menus[0].id;
      const route: string[] = [];
      menus.forEach((m) => {
        route.splice(0, 0, m.route);
      });
      if (route[route.length - 1] === 'patient_sample') {
        return;
      }
      else if (route[0] == 'inventory' && !environment.production) {
        this.isInventory = true;
        route.splice(0, 1);
        const queryParams:any = {};
        // Loop through the array and create query parameters
        queryParams['type_id']=type_id;
        route.forEach((item, index) => {
          const paramKey=index==0 ? 'inv_type' : `inv_cat${index-1}`;
          queryParams[paramKey] = item;
        });
        this.router.navigate(['inventory'], { queryParams})

      }
      else {
        this.router.navigate(route);
        this.isInventory = route[0] == 'inventory' ? true : false;
      }
    }
  }
  
  onClick(...menus: Menu[]) {
    if (menus.length && !menus[0].child?.length) {
      const route: string[] = [];
      menus.forEach((m) => {
        route.splice(0, 0, m.route);
      });
      if (route[route.length - 1] === 'patient_sample') {
        return;
      }
      else {
        this.router.navigate(route);
        this.isInventory = route[0] == 'inventory' ? true : false;
        this.isVedors = route[0] == 'vendors' ? true : false;
      }
    }
  }

  setActiveMenu(route: string): void {
    switch (route) {
      case 'inventory':
        this.isInventory = true;
        break;
      case 'vendors':
        this.isVedors = true;
        break;
      default:
        this.isInventory = false;
        this.isVedors = false;
        break;
    }
  }
  routeChange(flag: boolean) {
    this.isInventory = flag;
    this.isVedors = flag;
  }
  hasPermission(menuItem: string): boolean {
    return this.menu_items?.includes(menuItem);
  }


  inventoryTypeIds: Record<string, number> = {};
  setupTypeIdData(){
    const menu=[...this.menu,...this.vendorMenu];
    this.setTypeIds(menu);
    this.sharedService.inventoryTypeIds=this.inventoryTypeIds;
  }
  setTypeIds(menu: Menu[]): void {
    menu.forEach(item => {
      this.inventoryTypeIds[item.route] = item.id;
      if (item.child?.length) {
        this.setTypeIds(item.child);
      }
    });
  }

}
